import { isIdXboxGameInformationPricingAndAvailabilityFormValid } from "../../../../helpers/formValidation";
import {
  GameInformationPricingAndAvailabilityDataType,
  SubFormsDataTypes,
} from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const PricingAndAvailabilityDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const pricingData = data as GameInformationPricingAndAvailabilityDataType;
    if (!pricingData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationPricingAndAvailabilityFormValid(pricingData);
    return { result: validSchema };
  },
};
